var Promise = require('bluebird');
var GeoAPI = require("../api").GeoMatch;

// var PublicTree = null;
// var PrivateTree = null;
//
// exports.Setup = function(){
//   return Promise.all([
//     GeoAPI.GetFullTree(true).then(function(result) {
//       PublicTree = result;
//     }),
//     GeoAPI.GetFullTree(false).then(function(result) {
//       PrivateTree = result;
//     })
//   ]).then(function(results){
//     return {
//       public: results[0],
//       private: results[1]
//     }
//   })
// }

exports.Dialog = function(options){
  return {
    template: require("./dialog/index.pug")(),
    controller: require("./dialog/"),
    plain: true,
    disableAnimation: true,
    className: "ngdialog-theme-default geo-dialog",
    trapFocus: false,
    closeByDocument: false,
    resolve: {
      // public: function(){ return PublicTree },
      // private: function(){ return PrivateTree },
      options: function(){ return options }
    }
  }
}
